import { State, Module } from "app/decorators";
import BaseRoute from "app/routing";
import HitPercentageStore from "app/stores/hit_percentage";
import ReactModule from "app/react/react";

import { MixCalculatorCtrl } from "./ctrls";

import TicketStore from 'app/stores/ticket';
import CompanyStore from 'app/stores/company';
import ProductConfStore from 'app/stores/product.conf';
import mixCalculator from "./templates/mix.calculator.html";
import SecureUrlService from 'app/services/secure.url';
import UserService from 'app/services/user';

@Module({
  name: "app.admin.mix_calculator",
  modules: [BaseRoute, HitPercentageStore, ReactModule, TicketStore, ProductConfStore, CompanyStore, SecureUrlService, UserService],
})
@State({
  name: "r.in.top.admin.mix_calculator",
  url: "/mix-calculator",
  controllerProvider: function (Config) {
    "ngInject";
    const useReact = Config.isFeatureFlagActive('REACT_MIX_CALCULATOR');
    return useReact ? function () {} : MixCalculatorCtrl;
  },
  templateProvider: function (Config) {
    "ngInject";
    const useReact = Config.isFeatureFlagActive('REACT_MIX_CALCULATOR');
    return useReact
      ? `<div react-view="mix-calculator"></div>`
      : mixCalculator;
  },
  ncyBreadcrumb: {
    label: "Mix Calculator",
  },
  data: {
    permissions: {
      only: ["main.change_order"],
    },
  },
  resolve: {
    $ticket: function(Config, TicketStore) {
        if (Config.isFeatureFlagActive('REACT_MIX_CALCULATOR')) {
          return null;
        }
        return TicketStore.get('mix-calculator');
    },
    $prodConf: function(Config, ProductConfStore, $ticket) {
        if (Config.isFeatureFlagActive('REACT_MIX_CALCULATOR')) {
          return null;
        }
        ProductConfStore.params.company = $ticket.company.id;
        return ProductConfStore.refresh();
    },
    $company: function (Config, CompanyStore, $ticket, UserService) {
      if (Config.isFeatureFlagActive('REACT_MIX_CALCULATOR')) {
        return null;
      }
      if (UserService.$user.default_company) {
        return CompanyStore.get(UserService.$user.default_company);
      } else {
        return CompanyStore.get($ticket.company.id);
      }
    },
    $secureUrlService: function (Config, SecureUrlService) {
      if (Config.isFeatureFlagActive('REACT_MIX_CALCULATOR')) {
        return null;
      }
      return SecureUrlService
    }
},
})
export default class States {}



// WEBPACK FOOTER //
// ./src/app/admin/mix_calculator/routing.js